import { render, staticRenderFns } from "./userLogin.vue?vue&type=template&id=0fae3ce5"
import script from "./userLogin.vue?vue&type=script&lang=js"
export * from "./userLogin.vue?vue&type=script&lang=js"
import style0 from "./userLogin.vue?vue&type=style&index=0&id=0fae3ce5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports